import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { mergeStyles } from '@cian/utils';
import * as React from 'react';
var isEmpty = require('lodash.isempty');
import { ESuggestType, EInputType } from '../../types';
import * as styles from './styles.css';
import { SuggestionsGroup } from '../SuggestionGroup';
import { Suggestion } from '../Suggestion';
import { Message } from '../Message';
import { scrollTo } from '../../utils/scroll';
import { sortSuggestions } from '../../utils/suggestions';
import { isBuildingSuggest } from '../../utils/types';
import { jsx as _jsx } from "react/jsx-runtime";
export var SuggestionPopup = /*#__PURE__*/function (_React$Component) {
  _inherits(SuggestionPopup, _React$Component);
  var _super = _createSuper(SuggestionPopup);
  function SuggestionPopup() {
    var _this;
    _classCallCheck(this, SuggestionPopup);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "container", null);
    _defineProperty(_assertThisInitialized(_this), "suggestionElements", []);
    _defineProperty(_assertThisInitialized(_this), "lastSelectedIndex", 0);
    _defineProperty(_assertThisInitialized(_this), "scrollTo", function (index) {
      var center = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var containerElement = _this.container;
      var valueElement = _this.suggestionElements[index];
      if (!valueElement || !containerElement) {
        return;
      }
      var parentElement = valueElement.parentElement && valueElement.parentElement.parentElement;
      if (parentElement) {
        scrollTo({
          center: center,
          containerElement: containerElement,
          targetElement: valueElement,
          parentElement: parentElement
        });
      }
    });
    return _this;
  }
  _createClass(SuggestionPopup, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        containerStyles = _this$props.containerStyles,
        sortOrder = _this$props.suggestions.sortOrder,
        selectedItem = _this$props.selectedItem,
        onItemClick = _this$props.onItemClick,
        onLinkClick = _this$props.onLinkClick,
        _this$props$error = _this$props.error,
        error = _this$props$error === void 0 ? {} : _this$props$error,
        inputType = _this$props.inputType,
        itemsTruncation = _this$props.itemsTruncation;
      var suggestionsSorted = sortSuggestions(this.props.suggestions);
      var globalIndex = 0;
      var isMobileOrTablet = inputType === EInputType.mobile || inputType === EInputType.tablet;
      return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, mergeStyles(styles['geosuggest-popup'], containerStyles)), {}, {
        "data-name": "SuggestionPopup",
        children: !isEmpty(error) ? /*#__PURE__*/_jsx(Message, {
          title: error.title,
          text: error.text
        }) : /*#__PURE__*/_jsx("div", {
          className: styles['suggestion-list'],
          ref: function ref(container) {
            return _this2.container = container;
          },
          children: suggestionsSorted.map(function (group, index) {
            return group && /*#__PURE__*/_jsx(SuggestionsGroup, {
              name: sortOrder[index],
              children: group.map(function (item, index) {
                var elIndex = globalIndex++;
                var itemClickParams = item.type === ESuggestType.geo ? {
                  title: item.value,
                  group: ESuggestType.geo
                } : {
                  title: item.fullName,
                  group: item.type,
                  id: item.id,
                  regionId: item.regionId,
                  link: isBuildingSuggest(item) ? item.link : undefined
                };
                return /*#__PURE__*/_jsx(Suggestion, {
                  item: item,
                  selected: !isMobileOrTablet && elIndex === selectedItem,
                  inputType: inputType || EInputType.search,
                  onClick: function onClick() {
                    return onItemClick(itemClickParams);
                  },
                  onMouseOver: function onMouseOver() {
                    return _this2.onItemSelect(elIndex);
                  },
                  onLinkClick: function (_onLinkClick) {
                    function onLinkClick() {
                      return _onLinkClick.apply(this, arguments);
                    }
                    onLinkClick.toString = function () {
                      return _onLinkClick.toString();
                    };
                    return onLinkClick;
                  }(function () {
                    return onLinkClick && isBuildingSuggest(item) && onLinkClick(item.fullName, item.type, item.id);
                  }),
                  forwardRef: function forwardRef(itemElement) {
                    return _this2.suggestionElements[elIndex] = itemElement;
                  },
                  itemsTruncation: itemsTruncation
                }, index);
              })
            }, index);
          })
        })
      }));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevSelectedItem = prevProps.selectedItem;
      var selectedItem = this.props.selectedItem;
      if (selectedItem !== undefined && prevSelectedItem !== selectedItem && selectedItem !== this.lastSelectedIndex) {
        this.scrollTo(selectedItem);
        this.lastSelectedIndex = selectedItem;
      }
    }
  }, {
    key: "onItemSelect",
    value: function onItemSelect(index) {
      this.lastSelectedIndex = index;
      this.props.onItemSelect(index);
    }
  }]);
  return SuggestionPopup;
}(React.Component);